module.exports = __webpack_public_path__ + "static/media/tinywow_2589Erle_colored_55475686.109d679d.jpg";